export default {
    'diagram1-5a-5': {
        'diagram-task': 'Click the step buttons from step 1 to step 7',
        'step-1': 'STEP 1',
        'step-2': 'STEP 2',
        'step-3': 'STEP 3',
        'step-4': 'STEP 4',
        'step-5': 'STEP 5',
        'step-6': 'STEP 6',
        'step-7': 'STEP 7',
        'step-task': 'STEP 5 State how you will get from R1 to R2 (if you know it)',
        'situation': {
            'title': 'SITUATION',
            'text': `<ul>
                <li>Spends $600m every year on products/services</li>
                <li>Buys from hundreds of suppliers</li>
                <li>Many diverse procurement decisions</li>
                <li>Made by many different people with diverse backgrounds</li>
                <li>No formal supplier evaluation/qualification process</li>
            </ul>`,
        },
    }
}


// WEBPACK FOOTER //
// ./client/app/components/diagrams/5/5a/diagram1/i18n/en.js